import { useHistory } from "react-router";

import CategoriesManagementPage from "pages/admin/categories/Categories";
import PageWrapper from "components/PageWrapper";

export default function CategoriesRoute() {
  const history = useHistory();
  return (
    <PageWrapper
      label="Categories"
      navigationHandler={{ handleBack: () => history.push("/") }}
    >
      <CategoriesManagementPage />
    </PageWrapper>
  );
}
